import Cookies from 'universal-cookie';

const browserCookie = new Cookies();

export { browserCookie };
